import { ChangeDetectionStrategy, OnInit, Component, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { ViewerModel } from "../../../models/viewer-model";
import { E5coreUiAttachmentViewerBaseComponent } from "./e5core-ui-attachment-viewer-base";
import { E5ConfigurationService } from "e5core-angular-services";

@Component({
    selector: 'e5core-ui-weburi-attachment-viewer',
    template: `

    <span *ngIf="1==+behaviourType || forceInline">
        <iframe *ngIf="!(attachmentUrl == '')" [src]="attachmentUrl | safe" style="width:0;height:0;border:0; border:none; position: absolute;"></iframe>
    </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ {provide: E5coreUiAttachmentViewerBaseComponent, useExisting: E5coreUiWeburiAttachmentViewerComponent }]
})
export class E5coreUiWeburiAttachmentViewerComponent extends E5coreUiAttachmentViewerBaseComponent implements AfterViewInit, OnInit {
    forceInline = false;

    constructor(public e5ConfigurationService : E5ConfigurationService, public changeDetectorRef: ChangeDetectorRef) 
    {
        super(e5ConfigurationService, changeDetectorRef);
    }

    ngOnInit() {
    }
      
    ngAfterViewInit() {
    }

    public showPopViewer(viewerModel : ViewerModel) {
        this.forceInline = false;

        var fileName = (viewerModel.name != null) ? viewerModel.name.toLowerCase().trim() : viewerModel.fullUrl.toLowerCase().trim();
        if (fileName.endsWith(".doc") || fileName.endsWith(".docx") ||
          fileName.endsWith(".xls") || fileName.endsWith(".xlsx") ||
          fileName.endsWith(".ppt") || fileName.endsWith(".pptx")) {
  
              var filePrefix = "";
              if (fileName.endsWith(".doc") || fileName.endsWith(".docx")) {
                  filePrefix = "ms-word:nft|u|";
              }
              if (fileName.endsWith(".xls") || fileName.endsWith(".xlsx")) {
                  filePrefix = "ms-excel:nft|u|";
              }
              if (fileName.endsWith(".ppt") || fileName.endsWith(".pptx")) {
                  filePrefix = "ms-powerpoint:nft|u|";
              }
              viewerModel.fullUrl = filePrefix + viewerModel.fullUrl;

              this.forceInline = true;
              this.showInlineViewer(viewerModel);
            
              return;
          }

        this.constructViewerUrl(viewerModel, (vm, url) => this.performWindowPopup(vm, url));
    }

    public constructViewerUrl(viewerModel : ViewerModel, nextFunction : Function) : void {
        this.attachmentUrl = viewerModel.fullUrl;
        
        if (nextFunction)
            nextFunction(viewerModel, this.attachmentUrl);
    }

    public raiseEvent(viewerModel : ViewerModel) : void {
        this.viewerDisplayedEvent.emit({workId: viewerModel.workId, type: "WebUrl", attachmentId: null, fullUrl: viewerModel.fullUrl, name: null});
    }
}